<nav
  class="navbar navbar-expand-lg navbar-light header-navbar {{
    transparentBGClass
  }}"
  [ngClass]="{
    'navbar-brand-center': menuPosition === 'Top',
    'navbar-static':
      menuPosition === 'Side' && config?.layout.navbar.type === 'Static',
    'navbar-sticky':
      menuPosition === 'Side' && config?.layout.navbar.type === 'Fixed',
    'fixed-top': isSmallScreen && menuPosition === 'Top'
  }"
>
  <div class="container-fluid navbar-wrapper">
    <div class="navbar-header d-flex">
      <div
        class="navbar-toggle menu-toggle d-xl-none d-block float-left align-items-center justify-content-center"
        data-toggle="collapse"
        (click)="toggleSidebar()"
      >
        <i class="ft-menu font-medium-3"></i>
      </div>
      <ul class="navbar-nav" (clickOutside)="toggleSearchOpenClass(false)">
        <li class="nav-item mr-2 d-none d-lg-block">
          <a
            class="nav-link apptogglefullscreen"
            id="navbar-fullscreen"
            href="javascript:;"
            appToggleFullscreen
            (click)="ToggleClass()"
            ><i class=" {{ toggleClass }} font-medium-3"></i
          ></a>
        </li>
        <li class="nav-item nav-search mr-2">
          <a
            class="nav-link nav-link-search"
            id="navbar-search"
            href="javascript:"
            (ctrlF)="toggleSearchOpenClass(true)"
            (click)="toggleSearchOpenClass(true)"
            ><i class="ft-search font-medium-3"></i
          ></a>
          <div class="search-input {{ searchOpenClass }}">
            <div class="search-input-icon">
              <i class="ft-search font-medium-3"></i>
            </div>
            <input
              [formControl]="control"
              #search
              class="input"
              type="text"
              placeholder="Explore DRM..."
              tabindex="0"
              autofocus
              data-search="template-search"
              [appAutocomplete]="autocomplete"
              (keyup.enter)="onEnter()"
              (keydown.esc)="onEscEvent()"
              (keyup)="onSearchKey($event)"
            />
            <div
              class="search-input-close"
              (click)="toggleSearchOpenClass(false)"
            >
              <i class="ft-x font-medium-3"></i>
            </div>

            <app-autocomplete #autocomplete="appAutocomplete">
              <ng-template appAutocompleteContent>
                <ng-container
                  *ngIf="listItems | filter : control.value as result"
                >
                  <app-option
                    #searchResults
                    *ngFor="let option of result"
                    [url]="option.url"
                    [value]="option.name"
                    (click)="redirectTo(option.url)"
                    (mouseenter)="removeActiveClass()"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between w-100"
                    >
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <i class="{{ option.icon }} mr-2"></i>
                        <span>{{ option.name }}</span>
                      </div>
                    </div>
                  </app-option>
                  <app-option class="no-result" *ngIf="!result.length"
                    >No results found.</app-option
                  >
                </ng-container>
              </ng-template>
            </app-autocomplete>
          </div>
        </li>
        <li
          class="nav-item"
          *ngIf="authserive.isAdminCategory()"
          style="display: flex; justify-content: center"
        >
          <i
            [ngbPopover]="popContent"
            #popOver="ngbPopover"
            placement="bottom-end"
            [popoverTitle]="popTitle"
            [autoClose]="'outside'"
            (click)="getAllPackages()"
            class="fa fa-download font-medium-3 cursor-pointer"
            ngbTooltip="List of Downloaded Package"
            [ngClass]="{ 'popover-open': popOver.isOpen() }"
          ></i>
        </li>
      </ul>
      <div class="navbar-brand-center">
        <div class="navbar-header">
          <ul class="navbar-nav">
            <li class="nav-item">
              <div class="logo">
                <a
                  class="logo-text"
                  [routerLink]="['/']"
                  *ngIf="config?.layout.menuPosition === 'Top'"
                >
                  <div class="logo-img">
                    <img class="logo-img" alt="Apex logo" [src]="logoUrl" />
                  </div>
                  <span class="text">APEX</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="navbar-container">
      <div class="collapse navbar-collapse d-block" id="navbarSupportedContent">
        <ul class="navbar-nav" *ngIf="user$ | async as _user">
          <li *ngIf="authserive.isAdminCategory()"
              class="dropdown nav-item mr-3 position-relative d-flex align-items-center"
              placement="bottom-right"
              display="static"
              ngbDropdown>

            <!-- Bell Trigger Icon & Badge Counter -->
            <a class="nav-link position-relative p-0"
               href="javascript:;"
               id="notificationDropdown"
               ngbDropdownToggle>
              <i class="ft-bell font-medium-3 text-white"></i>
              <span *ngIf="totalNotificationCount > 0" class="badge badge-pill bg-warning notification-badge">
                {{ totalNotificationCount }}
              </span>
            </a>

            <!-- Custom Dark Theme Dropdown Menu -->
            <div class="dropdown-menu dropdown-menu-right custom-notification-dropdown m-0 p-0"
                 aria-labelledby="notificationDropdown"
                 ngbDropdownMenu>

              <!-- Header Title -->
              <div class="notification-header-title">
                <span>Notifications</span>
              </div>

              <!-- Scrollable List Wrapper -->
              <div class="scrollable-container notification-items-list">

                <div *ngIf="!notifications || notifications.length === 0" class="p-4 text-center text-muted context-fallback-text">
                  No new notifications found.
                </div>

                <div
                     class="notification-item"
                     *ngFor="let item of notifications"
                     [ngClass]="{'unread-bg': item.read === 1}"
                      (mouseenter)="onNotificationHover(item)">
                  <div class="notification-content d-flex align-items-start">

                    <div class="flex-grow-1">
                      <span class="notification-text mb-1">
                        {{ item.title }}
                      </span>
                      <div class="d-flex align-items-center style-gap-2 mt-2" style="gap: 10px;">
                        <button *ngIf="item.type !== 3" [routerLink]="['/right-holders/view', item.rights_holder]" class="btn btn-sm btn-orange text-white">
                          View Details
                        </button>

                        <button class="btn btn-sm btn-dismiss text-white"
                                [disabled]="item.isDismissing"
                                (click)="onDismiss(item, $event)">
                          <span *ngIf="item.isDismissing">
                            <i class="fa fa-spin fa-spinner mr-1"></i> Dismiss
                          </span>
                          <span *ngIf="!item.isDismissing">Dismiss</span>
                        </button>
                      </div>
                    </div>
                   </div>
                </div>
              </div>
            </div>
          </li>

          <li class="dropdown nav-item mr-1"
              placement="bottom-left"
              display="static"
              ngbDropdown>
            <a class="nav-link dropdown-toggle user-dropdown d-flex align-items-end"
               style="align-items: center!important;"
               id="dropdownBasic2"
               href="javascript:;"
               data-toggle="dropdown"
               ngbDropdownToggle>
              <div class="user d-md-flex d-none mr-2">
                <span class="text-right"> {{ _user.name }} </span>
                <ng-container *ngIf="company">
                  <span class="text-right text-muted font-small-2"> {{ company }} </span>
                </ng-container>
                <span class="text-right text-muted font-small-3">
                  <ng-container *ngIf="_user.type == 1">Super Admin</ng-container>
                  <ng-container *ngIf="_user.type == 2">Manager</ng-container>
                  <ng-container *ngIf="_user.type == 3">Creator</ng-container>
                  <ng-container *ngIf="_user.type == 4">Content Owner</ng-container>
                  <ng-container *ngIf="_user.type == 5">Manger Limited</ng-container>
                  <ng-container *ngIf="_user.type == 6">Viewer</ng-container>
                  <ng-container *ngIf="_user.type == 7">Viewer Limited</ng-container>
                  <ng-container *ngIf="_user.type == 8">Team Member (Content Owner)</ng-container>
                  <ng-container *ngIf="_user.type == 9">Team Member (Creator)</ng-container>
                  <ng-container *ngIf="_user.type == 10">Super Content Owner</ng-container>
                </span>
              </div>

              <img class="avatar"
                   [src]="_user.profile_picture"
                   alt="avatar"
                   height="35"
                   width="35" />
            </a>
            <div class="dropdown-menu text-left dropdown-menu-right m-0 pb-0"
                 aria-labelledby="dropdownBasic2"
                 ngbDropdownMenu>
              <a class="dropdown-item" [routerLink]="['/update-profile']">
                <div class="d-flex align-items-center">
                  <i class="ft-edit mr-2"></i><span>Edit Profile</span>
                </div>
              </a>
              <a class="dropdown-item"
                 [routerLink]="['/libraries/tab/favourites']">
                <div class="d-flex align-items-center">
                  <i class="ft-heart mr-2"></i><span>Favourites</span>
                </div>
              </a>
              <a class="dropdown-item"
                 [routerLink]="['/libraries/tab/downloaded']">
                <div class="d-flex align-items-center">
                  <i class="ft-download mr-2"></i><span>Downloaded</span>
                </div>
              </a>
              <a *ngIf="contentOwnerList.length > 0"
                 class="dropdown-item-switchAccount"
                 (click)="toggleMenu()"
                 style="position: relative">
                <div class="d-flex align-items-center">
                  <i class="ft-user mr-2"></i><span>Switch Account <i class="ft-chevron-right"></i></span>
                </div>
                <div *ngIf="isMenuVisible"
                     (click)="$event.stopPropagation()"
                     class="text-white"
                     style="
                    min-width: 275px;
                    position: absolute;
                    right: 102%;
                    top: 0px;
                    border-radius: 6px;
                    border: 1px solid #474748;
                    background-color: #101010;
                  ">
                  <!-- User 1 -->
                  <ng-container *ngFor="let owner of contentOwnerList; let isLast = last">
                    <div (click)="
                        changeDefaultRightHolder(owner.content_owner_id, owner.company)

                      "
                         class="d-flex align-items-center justify-content-between rightholderselection"
                         style="gap: 25px; padding: 15px">
                      <div class="d-flex align-items-center" style="gap: 8px">
                        <img class="rounded-circle d-flex justify-content-center align-items-center me-2"
                             width="40px"
                             height="40px"
                             [src]="owner.profile_picture" />
                        <div>
                          <div class="fw-bold">{{ owner.name }}</div>
                          <div class="text-muted small" *ngIf="!owner.type">{{ owner.company }}</div>

                          <div *ngIf="owner.type ==10">
                            <span class="badge badge-pill badge-secondary">All Assets</span>
                          </div>
                        </div>
                      </div>

                      <i *ngIf="defaultId == owner.content_owner_id"
                         class="ft-check text-white"></i>
                    </div>
                    <span *ngIf="!isLast" class="border-bottom d-block"></span>
                  </ng-container>
                  <!-- User 2 -->
                </div>
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" (click)="logout()">
                <div class="d-flex align-items-center">
                  <i class="ft-power mr-2"></i><span>Logout</span>
                </div>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>

<ng-template #popContent>
  <div class="row">
    <div class="col-md-12" style="max-height: 450px; overflow-y: scroll">
      <div class="table-container">
        <table *ngIf="rows.length > 0">
          <thead>
            <tr>
              <th>Title</th>
              <th style="width: 250px">Download</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let package of rows">
              <td>{{ package.title }}</td>
              <td>
                <button
                  class="btn btn-sm bg-light-success mr-1"
                  (click)="downloadPackage(package.id, package.file)"
                >
                  <i class="fa fa-download"></i> Download ZIP
                </button>
                <button
                  class="btn btn-sm bg-light-danger"
                  (click)="
                    packageId !== package._id
                      ? deletePackage(package._id)
                      : null
                  "
                >
                  <i class="fa fa-trash"></i> Delete
                  <i
                    class="fa fa-spin fa-spinner"
                    *ngIf="packageId == package._id"
                  ></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <p
          *ngIf="rows.length == 0"
          style="text-align: center; margin-top: 15px"
        >
          No Result Found!
        </p>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #popTitle>
  Downloaded Package <i class="fa fa-spin fa-spinner" *ngIf="spinnrow"></i>
</ng-template>
